var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"practicalt"},[_c('div',{staticClass:"mob",style:({display: _vm.belong})}),_c('video-player',{ref:"videoPlayer",staticClass:"video-player vjs-custom-skin",style:({display: _vm.belongs}),attrs:{"playsinline":true,"options":_vm.playerOptions},on:{"ended":function($event){return _vm.onPlayerEnded($event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }